import * as types from './types';

const mutations = {
  [types.RESET](state) {
    state.profile = {};
    state.jobApplications = [];
    state.resume = {
      jobs: {},
      educations: {},
      languages: {},
      certifications: {},
    };
    state.cooperationAgreements = [];
  },
  // FETCH_EMPLOYEE_PROFILE
  [types.FETCH_EMPLOYEE_PROFILE_PENDING](state) {
    state.fetchEmployeeProfilePending = true;
  },
  [types.FETCH_EMPLOYEE_PROFILE_FULFILLED](state, data) {
    state.profile = data;
    state.fetchEmployeeProfilePending = false;
  },
  [types.FETCH_EMPLOYEE_PROFILE_ERROR](state) {
    state.fetchEmployeeProfilePending = false;
  },
  // UPDATE_EMPLOYEE_PROFILE
  [types.UPDATE_EMPLOYEE_PROFILE_PENDING](state) {
    state.updateEmployeeProfilePending = true;
  },
  [types.UPDATE_EMPLOYEE_PROFILE_FULFILLED](state) {
    state.updateEmployeeProfilePending = false;
  },
  [types.UPDATE_EMPLOYEE_PROFILE_ERROR](state) {
    state.updateEmployeeProfilePending = false;
  },
  // FETCH_RESUME
  [types.FETCH_RESUME_PENDING](state) {
    state.fetchResumePending = true;
  },
  [types.FETCH_RESUME_FULFILLED](state, { data }) {
    state.resume = data.data;
    state.fetchResumePending = false;
  },
  [types.FETCH_RESUME_ERROR](state) {
    state.fetchResumePending = false;
  },
  // FETCH_RESUME
  [types.FETCH_RESUME_ITEM_PENDING](state) {
    state.fetchResumeItemPending = true;
  },
  [types.FETCH_RESUME_ITEM_FULFILLED](state) {
    state.fetchResumeItemPending = false;
  },
  [types.FETCH_RESUME_ITEM_ERROR](state) {
    state.fetchResumeItemPending = false;
  },
  // STORE_RESUME_ITEM
  [types.STORE_RESUME_ITEM_PENDING](state) {
    state.storeResumeItemPending = true;
  },
  [types.STORE_RESUME_ITEM_FULFILLED](state) {
    state.storeResumeItemPending = false;
  },
  [types.STORE_RESUME_ITEM_ERROR](state) {
    state.storeResumeItemPending = false;
  },
  // DELETE_RESUME_ITEM
  [types.DELETE_RESUME_ITEM_PENDING](state) {
    state.deleteResumeItemPending = true;
  },
  [types.DELETE_RESUME_ITEM_FULFILLED](state) {
    state.deleteResumeItemPending = false;
  },
  [types.DELETE_RESUME_ITEM_ERROR](state) {
    state.deleteResumeItemPending = false;
  },
  // FETCH_APPLICATIONS
  [types.FETCH_APPLICATIONS_PENDING](state) {
    state.fetchApplicationsPending = true;
  },
  [types.FETCH_APPLICATIONS_FULFILLED](state, { data, listType }) {
    state.jobApplications[listType] = data.data;
    state.fetchApplicationsPending = false;
  },
  [types.FETCH_APPLICATIONS_ERROR](state) {
    state.fetchApplicationsPending = false;
  },
  // STORE_APPLICATION
  [types.STORE_APPLICATION_PENDING](state) {
    state.storeApplicationPending = true;
  },
  [types.STORE_APPLICATION_FULFILLED](state) {
    state.storeApplicationPending = false;
  },
  [types.STORE_APPLICATION_ERROR](state) {
    state.storeApplicationPending = false;
  },
  // SAVE_APPLICATION_IN_EDIT
  [types.SAVE_APPLICATION_IN_EDIT](state, payload) {
    state.applicationInEdit = payload;
  },
  // DELETE_JOB_APPLICATION
  [types.DELETE_JOB_APPLICATION_PENDING](state) {
    state.deleteApplicationPending = true;
  },
  [types.DELETE_JOB_APPLICATION_FULFILLED](state, { data }) {
    state.deleteApplicationPending = false;
  },
  [types.DELETE_JOB_APPLICATION_ERROR](state) {
    state.deleteApplicationPending = false;
  },
  // FETCH_COOPERATION_AGREEMENTS
  [types.FETCH_COOPERATION_AGREEMENTS_PENDING](state) {
    state.fetchCooperationAgreementsPending = true;
  },
  [types.FETCH_COOPERATION_AGREEMENTS_FULFILLED](state, { data }) {
    state.cooperationAgreements = data.data;
    state.fetchCooperationAgreementsPending = false;
  },
  [types.FETCH_COOPERATION_AGREEMENTS_ERROR](state) {
    state.fetchCooperationAgreementsPending = false;
  },
};

export default mutations;
